import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { toast } from "react-toastify";
import ErrorToastContent from "./ErrorToastContent";
function stliteStyledPromiseToast(promise, messages) {
    const errorMessage = messages.error;
    return toast.promise(promise, {
        pending: messages.pending,
        success: messages.success,
        error: typeof errorMessage === "string"
            ? {
                render({ data }) {
                    return data ? (_jsx(ErrorToastContent, { message: errorMessage, error: data })) : (_jsx(_Fragment, { children: "messages.error" }));
                },
                autoClose: false,
                closeOnClick: false,
            }
            : errorMessage,
    }, {
        hideProgressBar: true,
        position: "bottom-right",
    });
}
export class StliteKernelWithToast {
    kernel;
    constructor(kernel, options) {
        this.kernel = kernel;
        kernel.onModuleAutoLoad = (packagesToLoad, installPromise) => {
            if (options?.onModuleAutoLoad) {
                options.onModuleAutoLoad(packagesToLoad, installPromise);
            }
            stliteStyledPromiseToast(installPromise, {
                success: {
                    render({ data }) {
                        return `Auto-loaded${data ? ": " + data.map((pkg) => pkg.name).join(", ") : " packages"}`;
                    },
                },
                error: "Failed to auto-load packages",
                pending: "Auto-loading packages",
            });
        };
    }
    writeFile(...args) {
        return stliteStyledPromiseToast(this.kernel.writeFile(...args), {
            error: "Failed to write the file",
        });
    }
    renameFile(...args) {
        return stliteStyledPromiseToast(this.kernel.renameFile(...args), {
            error: "Failed to rename the file",
        });
    }
    unlink(...args) {
        return stliteStyledPromiseToast(this.kernel.unlink(...args), {
            error: "Failed to remove the file",
        });
    }
    readFile(...args) {
        return stliteStyledPromiseToast(this.kernel.readFile(...args), {
            error: "Failed to read the file",
        });
    }
    install(...args) {
        return stliteStyledPromiseToast(this.kernel.install(...args), {
            pending: "Installing",
            success: "Successfully installed",
            error: "Failed to install",
        });
    }
    reboot(...args) {
        return stliteStyledPromiseToast(this.kernel.reboot(...args), {
            pending: "Rebooting",
            success: "Successfully rebooted",
            error: "Failed to reboot",
        });
    }
}
//# sourceMappingURL=stlite-kernel-with-toast.js.map